import { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import FluigService from "../../../../services/resource/fluigComprasService";
import { Loading } from "../../../../componentes/loading/loading";

export default function ResumoPorPrioridade({ dataInicial, dataFinal, filtrar, openModal }) {
  const service = new FluigService();
  const [chartOptions, setChartOptions] = useState({});
  const [chartSeries, setChartSeries] = useState([]);
  const [tamanho, settamanho] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    service
      .resumoPorPrioridade(dataInicial, dataFinal)
      .then((response) => {
        const data = response?.data ?? [];
        settamanho(data.length);

        const labels = data.map((item) => item.status || "—");
        const values = data.map((item) => item.total || 0);

        setChartOptions({
          chart: {
            type: "pie",
            events: {
              dataPointSelection: (event, chartContext, config) => {
                const index = config.dataPointIndex;
                const label = labels[index];
                openModal(label, "prioridade");
              },
            },
          },
          labels,
          legend: {
            position: "bottom",
          },
          tooltip: {
            custom: ({ series, seriesIndex }) => {
              const total = series[seriesIndex];
              return `<div style="padding: 8px;">Total Solicitações: <strong>${total}</strong></div>`;
            },
          },
          stroke: {
            show: false,
            width: 0
          },
          colors: [
            "#e9e635ff", // alta
            "#4b5ae0ff", // moderada
            "#eb2323ff", // emergencial
            "#51f63bff", // baixa
          ],
        });

        setChartSeries(values);
      })
      .catch((err) => console.error("Erro ao buscar API:", err))
      .finally(() => setLoading(false));
  }, [filtrar]);

  return (
    <div className="bg-card border border-border rounded-lg shadow-card p-4 lg:col-span-1">
      <h3 className="text-lg font-display font-semibold text-foreground mb-1">
        Solicitações por Prioridade
      </h3>
      <label className="text-muted-foreground text-sm">
        Total de Solicitações por Prioridade.
      </label>
      <div className="h-64">
        {!loading && tamanho > 0 ? (
          <Chart
            options={chartOptions}
            series={chartSeries}
            type="pie"
            height="100%"
          />
        ) : !loading ? (
          "Não existem dados disponíveis para o intervalo selecionado."
        ) : (
          <Loading />
        )}
      </div>
    </div>
  );
}